import React, { useCallback } from 'react';

import { Linking } from 'react-native';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { BUTTON_SUBSCRIBE } from 'config/testID';

import { selectLayoutConfig } from 'store/config/selectors';
import { getEntitlements } from 'store/user/actions';

import { isTabletOrWeb } from 'utils/responsiveness';

import styles from 'screens/Detail/components/DetailPageButtons/styles';
import {
    CLOSE_BUTTON,
    SELFCARE_APP_BUTTON,
    SUBSCRIBE_OVERLAY_DESCRIPTION_REACT_NATIVE,
    SUBSCRIBE_OVERLAY_SELFCARE_LINK,
    SUBSCRIBE_OVERLAY_TITLE,
} from 'screens/Detail/languageConst';

import DialogView from 'components/Dialog';
import dialogStyles from 'components/Dialog/style';

type DetailPageSubscribeModalProps = {
    isModalOpen: boolean;
    onCloseModal(): void;
};

const TEN_MINUTES_IN_MS = 600000;

function DetailPageSubscribeModal({
    isModalOpen,
    onCloseModal,
}: DetailPageSubscribeModalProps) {
    const { primary } = useSelector(selectLayoutConfig);
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const onCloseSubscriptionModal = useCallback(() => {
        onCloseModal();

        dispatch(getEntitlements({ autoRetry: true }));
        setTimeout(() => {
            dispatch(getEntitlements({ autoRetry: true }));
        }, TEN_MINUTES_IN_MS);
    }, [onCloseModal]);

    const handleSubscriptionRedirect = useCallback(() => {
        Linking.openURL(t(SUBSCRIBE_OVERLAY_SELFCARE_LINK));
    }, []);

    return isModalOpen ? (
        <DialogView
            style={dialogStyles.nonTransparentDialog}
            title={SUBSCRIBE_OVERLAY_TITLE}
            description={SUBSCRIBE_OVERLAY_DESCRIPTION_REACT_NATIVE}
            visible={isModalOpen}
            actionButtonTitle={SELFCARE_APP_BUTTON}
            actionButtonFillColor={primary}
            actionButtonTextStyle={styles.buttonText}
            actionButtonOnPress={handleSubscriptionRedirect}
            actionButtonStyle={isTabletOrWeb && styles.actionButtonStyle}
            cancelButtonTitle={CLOSE_BUTTON}
            cancelButtonBordered
            cancelButtonOnPress={onCloseSubscriptionModal}
            actionButtonTestID={BUTTON_SUBSCRIBE}
            closeButtonTestID={CLOSE_BUTTON}
            descriptionNumberOfLines={0}
        />
    ) : null;
}

export default DetailPageSubscribeModal;
